import uniq from 'lodash-es/uniq'

import { EMPTY_LIST } from '../../constants/common'
import {
  getStorageSerializedItem,
  removeStorageItem,
} from '../../utils/storage'

import {
  BIRDVIEW_ANALYTICS_LAYOUT_KEYS,
  BIRDVIEW_DASHBOARD_LAYOUT_KEYS,
  BIRDVIEW_STORAGE_ITEM_SET_SEPARATOR,
  BIRDVIEW_STORAGE_KEY_SEPARATOR,
} from './DashboardBirdview.constants'

export function getBirdviewStorageKey(baseKey, parts) {
  return [baseKey, ...parts].join(BIRDVIEW_STORAGE_KEY_SEPARATOR)
}

// Each skeleton lays out its own widgets, so a previewed role must not reorder
// the dashboard the user actually works in.
export function getBirdviewStorageScope({ role, userId }) {
  return getBirdviewStorageKey(userId, [role])
}

export function getBirdviewLayoutStorageKeys({
  isAnalyticsView,
  storageScope,
}) {
  return (
    isAnalyticsView
      ? BIRDVIEW_ANALYTICS_LAYOUT_KEYS
      : BIRDVIEW_DASHBOARD_LAYOUT_KEYS
  ).map(baseKey => getBirdviewStorageKey(baseKey, [storageScope]))
}

// The stored keys end with the item set, so a reset matches them by prefix.
export function clearBirdviewStoredLayout(prefixes) {
  Object.keys(localStorage)
    .filter(key => prefixes.some(prefix => key.startsWith(prefix)))
    .forEach(key => removeStorageItem(key))
}

export function getBirdviewStorageItemSetKey(ids) {
  return ids.join(BIRDVIEW_STORAGE_ITEM_SET_SEPARATOR)
}

export function readBirdviewStorageItem(storageKey, checkIsValid) {
  const parsed = getStorageSerializedItem(storageKey)

  return checkIsValid(parsed) ? parsed : null
}

// Ids that left the item set are dropped on read.
export function readBirdviewStoredIds(storageKey, ids) {
  const stored = readBirdviewStorageItem(storageKey, Array.isArray)

  return stored ? stored.filter(id => ids.includes(id)) : EMPTY_LIST
}

export function reconcileBirdviewOrder(stored, defaultOrder) {
  if (!stored) {
    return defaultOrder
  }

  const allowed = new Set(defaultOrder)
  const kept = uniq(stored).filter(id => allowed.has(id))
  const missing = defaultOrder.filter(id => !kept.includes(id))

  return [...kept, ...missing]
}
